import * as constants from './constants';
import { useGetUserClaimGroupAbilities } from './userAbilities';
export function setupMarket() {
  window.MARKET_CONSTANTS = constants;
  window.MARKET_SETUP = {
    useGetUserClaimGroupAbilities: useGetUserClaimGroupAbilities
  };
}